module.exports = __webpack_public_path__ + "img/20220531_luna_airdrop.1031c523.png";